<template>
    <InsightCategoryChip v-if="variant === 'chip'" :color="color" size="2xs" class="h-auto min-h-5.5 text-pretty whitespace-normal">{{ label }}</InsightCategoryChip>
    <div v-else class="flex items-center gap-2" :class="colorClasses[color]">
        <span class="category-dot size-2 shrink-0 rounded-full" aria-hidden="true"></span>
        <span class="scaffold-details-small text-ink-muted text-pretty">{{ label }}</span>
    </div>
</template>

<script setup lang="ts">
import InsightCategoryChip from "~vue/components/InsightCategoryChip.vue";
import { colorForExperimentSlug, INSIGHT_CATEGORY_PALETTE, InsightCategoryColor, type InsightTier } from "~vue/Labs/insightCategory";
import { computed } from "vue";

const props = withDefaults(
    defineProps<{
        label: string;
        tier?: InsightTier;
        experimentSlug?: string;
        /** "dot" is the control style; "chip" is the pill badge used by the redesigned layout. */
        variant?: "dot" | "chip";
    }>(),
    { variant: "dot" },
);

const color = computed(() => (props.tier ? INSIGHT_CATEGORY_PALETTE[props.tier - 1] : colorForExperimentSlug(props.experimentSlug)));

const colorClasses: Record<InsightCategoryColor, string> = {
    teal: "category-teal",
    pink: "category-pink",
    orange: "category-orange",
    green: "category-green",
};
</script>

<style scoped>
@reference "../../../css/tailwind.css";

@layer components {
    .category-teal {
        --base-chip-bg: var(--color-lab-insight-category-teal-bg);
        --base-chip-text: var(--color-lab-insight-category-teal-text);
    }

    .category-pink {
        --base-chip-bg: var(--color-lab-insight-category-pink-bg);
        --base-chip-text: var(--color-lab-insight-category-pink-text);
    }

    .category-orange {
        --base-chip-bg: var(--color-lab-insight-category-orange-bg);
        --base-chip-text: var(--color-lab-insight-category-orange-text);
    }

    .category-green {
        --base-chip-bg: var(--color-lab-insight-category-green-bg);
        --base-chip-text: var(--color-lab-insight-category-green-text);
    }

    .category-dot {
        background-color: var(--base-chip-text);
    }
}
</style>
